module.exports = __webpack_public_path__ + "img/Group8@2x.91162dce.png";